import PreviewDetailImg from 'assets/images/feature-slots/preview_detail.png';
import PreviewDListlImg from 'assets/images/feature-slots/preview_list.png';
import { getRouteName, SLOT_KEY } from './common';

const MODULE_NAME = 'Customer';

const routes = [
    {
        matchRegex: '/Customer',
        name: getRouteName(MODULE_NAME, 'Listing'),
        slots: [
            SLOT_KEY.SLOT_ADDITION_MENU,
            SLOT_KEY.SLOT_STATIC_SCRIPT,
            SLOT_KEY.SLOT_V_TABLE_COLUMN,
            SLOT_KEY.SLOT_SCRIPTS,
            SLOT_KEY.SLOT_V_FORM_FILTER,
            SLOT_KEY.SLOT_V_FORM_ADVANCED_FILTER,
        ],
        image: PreviewDListlImg,
        options: {
            [SLOT_KEY.SLOT_SCRIPTS]: [
                { key: 'MARKETPLACE_EVENT_TAB_CHANGE', label: 'Before Tab Change' },
                { key: 'MARKETPLACE_EVENT_TOGGLE_VIEW', label: 'Before Toogle View' },
                {
                    key: 'MARKETPLACE_EVENT_TOGGLE_BATCHING',
                    label: 'Before Toogle Batching',
                },
                {
                    key: 'MARKETPLACE_EVENT_TOGGLE_TABLE_SETTING',
                    label: 'Before Toogle Table Setting',
                },
            ],
            [SLOT_KEY.SLOT_STATIC_SCRIPT]: [
                { key: 'add-customer', label: 'Button Add Customer' },
                { key: 'print', label: 'Button Print' },
                { key: 'import', label: 'Button Import' },
                { key: 'export', label: 'Button Export' },
            ],
        },
    },
    {
        matchRegex: '/Customer/Create',
        name: getRouteName(MODULE_NAME, 'Create'),
        slots: [
            SLOT_KEY.SLOT_V_RIGHT_INNER_FORM_SECTION,
            SLOT_KEY.SLOT_V_RIGHT_FORM_SECTION,
            SLOT_KEY.SLOT_V_LEFT_INNER_FORM_SECTION,
            SLOT_KEY.SLOT_V_LEFT_FORM_SECTION,
            SLOT_KEY.SLOT_V_FORM_SECTION,
        ],
        image: PreviewDListlImg,
    },
    {
        matchRegex: '/Customer/Detail/:id',
        name: getRouteName(MODULE_NAME, 'Detail'),
        slots: [
            SLOT_KEY.SLOT_ADDITION_MENU,
            SLOT_KEY.SLOT_TAB,
            SLOT_KEY.SLOT_CONTENT,
            SLOT_KEY.SLOT_STATIC_SCRIPT,
            SLOT_KEY.SLOT_V_TABLE_COLUMN,
            SLOT_KEY.SLOT_SECTION_ACTION,
            SLOT_KEY.SLOT_SCRIPTS,
            SLOT_KEY.SLOT_MVC_FORM_SECTION,
            SLOT_KEY.SLOT_MVC_FORM_INNER_SECTION,
            SLOT_KEY.SLOT_V_FORM_INNER_SECTION,
            SLOT_KEY.SLOT_V_FORM_SECTION,
            SLOT_KEY.SLOT_SECTION
        ],
        image: PreviewDetailImg,
        description: {
            [SLOT_KEY.SLOT_TAB]: `Embedded source: "id" must be startwith prefix "MarketplaceTab_"`,
            [SLOT_KEY.SLOT_CONTENT]: `Embedded source: "id" must be startwith prefix "MarketplaceTab_"`,
        },
        parentKeys: {
            [SLOT_KEY.SLOT_V_TABLE_COLUMN]: [
                { key: 'site-table', label: 'Site Table' },
                { key: 'job-table', label: 'Job Table' },
                { key: 'invoice-table', label: 'Invoice Table' },
                { key: 'ppm-contract-table', label: 'PPM Contract Table' },
                { key: 'ppm-quote-table', label: 'PPM Quote Table' },
                { key: 'audit-table', label: 'Audit Table' },
                { key: 'invoice-list', label: 'Invoice List' },
            ],
            [SLOT_KEY.SLOT_SECTION_ACTION]: [
                { key: 'detail-tab-form', label: 'Detail Form' },
                { key: 'billing-tab-form', label: 'Billing Form' },
                { key: 'configuration-tab-form', label: 'Configuration Form' },
                { key: 'warning-notices-tab-form', label: 'Warning Notices Form' }
            ],
            [SLOT_KEY.SLOT_MVC_FORM_SECTION]: [
                { key: 'detail-tab', label: 'Detail Tab' },
                { key: 'billing-tab', label: 'Billing Tab' },
                { key: 'address-map-tab', label: 'Address Map Tab' },
                { key: 'warning-notices-tab', label: 'Warning Notices Tab' },
            ],
            [SLOT_KEY.SLOT_MVC_FORM_INNER_SECTION]: [
                { key: 'detail-tab', label: 'Detail Tab' },
                { key: 'billing-tab', label: 'Billing Tab' },
            ],
            [SLOT_KEY.SLOT_V_FORM_INNER_SECTION]: [
                { key: 'configuration-tab', label: 'Configuration Tab' },
                { key: 'warning-notices-tab', label: 'Warning Notices Tab' },
                { key: 'invoice-details-tab', label: 'Invoice Details Tab' },
            ],
            [SLOT_KEY.SLOT_V_FORM_SECTION]: [
                { key: 'contacts-tab', label: 'Contacts Tab' },
                { key: 'notes-tab', label: 'Notes Tab' },
            ],
            [SLOT_KEY.SLOT_SECTION]: [
                { key: 'section-search-job-filter', label: 'Advanced Search Filter' },
            ],
        },
        options: {
            [SLOT_KEY.SLOT_STATIC_SCRIPT]: [
                { key: 'log-job', label: 'Button Log Job' },
                { key: 'log-quote', label: 'Button Log Quote' },
                { key: 'add-invoice', label: 'Button AddInvoice' },
                { key: 'add-site', label: 'Button Add Site' },
                { key: 'import-sites', label: 'Button Import Sites' },
            ],
        },
    },
    {
        matchRegex: '/Customer/CustomerContractDetail/:id',
        name: getRouteName(MODULE_NAME, 'ContractDetail'),
        slots: [
            SLOT_KEY.SLOT_V_SECTION
        ],
        image: PreviewDetailImg,
        description: {
            [SLOT_KEY.SLOT_V_SECTION]: `Embedded source: "id" must be startwith prefix "MarketplaceTab_"`,
        },
        parentKeys: {
            [SLOT_KEY.SLOT_V_SECTION]: [
                { key: 'site-assign-section', label: 'Site Assign Section' },
            ],
        },
        options: {
            [SLOT_KEY.SLOT_STATIC_SCRIPT]: [
                { key: 'contract-site-assign', label: 'Contract Site Assign' },     
            ],
        },
    },
]

export default routes;